export default (() => {

  class MainNavigationDesktop {
    constructor() {
      this.$levelOneItem = $('.main-navigation-desktop-l1-item');
      this.$levelOneLink = $('.main-navigation-desktop-l1-link');
      this.$levelTwoMenu = $('.main-navigation-desktop-l2');
      this.$menuTrigger = $('.js-menu-trigger');
      this.$menuTarget = $('.js-menu-target');
    }

    dynamicMenuSize(reset = false, limit = false) {
      const self = this;

      this.$levelTwoMenu.each(function() {
        const $menu = $(this);

        if(reset) {
          $menu.css('height', '82px');
        }

        let resize = true;
        let maxResizeCount = 0
        while(resize && maxResizeCount < 90) {
          resize = self.checkSize($menu);
          if (limit) {
            maxResizeCount++;
          }
        }
      });
    }

    checkSize($menu) {
      let resized = false;

      let viewportOffset = $menu.offset();
      if(!viewportOffset) {
        return false;
      }

      let amBottom = viewportOffset.top + $menu.outerHeight();
      let amRight = viewportOffset.left + $menu.outerWidth();

      $menu.find('.main-navigation-desktop-l2-item').each(function() {
        let l2ViewportOffset = $(this).offset();
        let l2Bottom = l2ViewportOffset.top + $(this).outerHeight();
        let l2Right = l2ViewportOffset.left + $(this).outerWidth();

        if(l2Bottom > (amBottom - 20) || l2Right > amRight) {
          $menu.css('height', ($menu.outerHeight() + 1) + 'px');
          resized = true;
          return false; // Break .each loop
        }
      });

      return resized;
    }

    levelOneHover(e) {
      const self = this;
      const $this = $(e.target);
      $this.parent().find(this.$levelTwoMenu).addClass('active');
      self.dynamicMenuSize();
    }

    levelOneLeave(e) {
      const $this = $(e.target);
      this.$levelTwoMenu.removeClass('active');
    }

    levelOneFocus(e) {
      const $this = $(e.target);
      this.$levelTwoMenu.removeClass('active');
      $this.parent().find(this.$levelTwoMenu).addClass('active');
    }

    init() {
      this.$levelOneItem.on('mouseenter', (e) => this.levelOneHover(e));
      this.$levelOneItem.on('mouseleave', (e) => this.levelOneLeave(e));
      this.$levelOneLink.on('focusin', (e) => this.levelOneFocus(e));

      this.$levelOneLink.first().on('keydown', (e) => {if (e.which == 9 && e.shiftKey) this.levelOneLeave(e)});
      $('.main-navigation-desktop-l1-item:last-child .main-navigation-desktop-l2-item:last-child a:last-of-type').on('keydown', (e) =>  {
        if (e.target.nextElementSibling == null && e.which == 9) {
          this.levelOneLeave(e);
        }
      });


      this.dynamicMenuSize(true, true);

      var mainnavigationnotification = window.getCookie("mainnavigationnotification");
      if (!mainnavigationnotification) {
        $('.js-main-navigation-notification').removeClass('js-main-navigation-notification-closed')
        $('.js-main-navigation-desktop-notification-close').click(function () {
          $('.js-main-navigation-notification').addClass('js-main-navigation-notification-closed')
          document.cookie = "mainnavigationnotification=false; path=/;";
        })
      }

    }
  }

  const mainNavigation = new MainNavigationDesktop();
  mainNavigation.init();
})()
